module.exports = function(){
	console.log("largeNonCommonFunction")
}



// WEBPACK FOOTER //
// source/js/css/largeNonCommonFunction.js